export const oneSecondInMilliseconds = 1e3;
